import React, { useEffect } from "react";
import { X, ClipboardList } from "lucide-react";
import { useForm, Controller } from "react-hook-form";

const AddDispositionModal = ({ isOpen, onClose,  onSave, itemData}) => {
  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      disposition: "",
      sub_disposition: "",
    },
  });

  console.log(itemData)
  // Reset form on edit / open
  useEffect(() => {
    if (itemData) {
      reset({
        disposition: itemData.disposition || "",
        sub_disposition: itemData.sub_disposition || "",
      });
    } else {
      reset();
    }
  }, [itemData, isOpen, reset]);

  const onSubmit = (data) => {
    const payload = {
      disposition: data.disposition.trim(),
      sub_disposition: data.sub_disposition.trim(),
    };

    onSave(payload);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="add-subparam-overlay">
      <div className="add-subparam-modal">
        {/* Header */}
        <div className="add-subparam-header">
          <h3>
            <ClipboardList size={18} style={{ marginRight: "6px" }} />
            {itemData ? "Edit Disposition" : "Add Disposition"}
          </h3>
          <button onClick={onClose} className="close-btn">
            <X size={20} />
          </button>
        </div>

        {/* Body */}
        <form
          id="dispositionForm"
          onSubmit={handleSubmit(onSubmit)}
          className="add-subparam-body"
        >
          <label>Disposition</label>
          <Controller
            name="disposition"
            control={control}
            rules={{ required: "Disposition is required" }}
            render={({ field }) => (
              <input
                {...field}
                className={`form-control ${errors.disposition ? "error" : ""}`}
                placeholder="Enter disposition"
              />
            )}
          />
          {errors.disposition && (
            <p className="error-text">{errors.disposition.message}</p>
          )}

          <label>Sub Disposition</label>
          <Controller
            name="sub_disposition"
            control={control}
            render={({ field }) => (
              <input
                {...field}
                className="form-control"
                placeholder="Enter sub disposition (optional)"
              />
            )}
          />
        </form>

        {/* Footer */}
        <div className="add-subparam-footer">
          <button
            type="button"
            className="popup-cancel-btn"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            type="submit"
            form="dispositionForm"
            className="popup-add-btn"
          >
            {itemData ? "Update" : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddDispositionModal;
